var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab,staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: tab === _vm.selected },on:{"click":function($event){return _vm.setTab(tab)}}},[_vm._v(" "+_vm._s(tab)+" ")])])}),0),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }